import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useUIMode } from "../hooks/useUIMode";
import { UserContext } from "../UserContext";
import { hasAnyPerm } from '../utils/uiUtils';
import { useTranslation } from 'react-i18next';
import { axiosAuth_ASSET_MGMT_API } from '../utils/AxoisUtilComponent';
import TemplateListView from "./TemplateListView";
import AssetTypeAdminDetailsView from "./AssetTypeAdminDetailsView";
import AssetTypeAdminNewView     from "./AssetTypeAdminNewView";


const AssetTypeAdmin = () => {

  const { t }    = useTranslation(["common"]);
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const { uiMode, setUIMode, objDetails, setObjDetails } = useUIMode('LIST');

  const PAGE_STATE_STORAGE_KEY = "AssetTypeAdmin.pageState";
  const defaultPageState = {
    searchTerms: null,
    sortCol: null,
    sortDir: null,
    perPage: 25,
    currPage: 1
  };

  const [pageState, setPageState] = useState(() => {
    try {
      const savedPageState = sessionStorage.getItem(PAGE_STATE_STORAGE_KEY);
      return savedPageState
        ? { ...defaultPageState, ...JSON.parse(savedPageState) }
        : defaultPageState;
    } catch (error) {
      return defaultPageState;
    }
  });

  useEffect(() => {
    sessionStorage.setItem(PAGE_STATE_STORAGE_KEY, JSON.stringify(pageState));
  }, [pageState]);

  // Initialize state
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["BuildingAdminGeneralWriteAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // ----- Data Table stuff -----

  const tableColumns = [
    {
      igcColumnType: 'PRIMARY_ID',
      igcFieldName: 'code',
      name: t("I18N_Asset_type_code"),
      sortable: true,
      sortField: 'code',
      grow: 2,
      cell: null
    },
    {
      name: t("I18N_Name"),
      selector: row => row.name,
      sortable: true,
      sortField: 'code',
      grow: 2,
      wrap: true
    },
    {
      name: t("I18N_Description"),
      selector: row => row.description,
      grow: 3,
      wrap: true
    },
    {
      name: t("I18N_Class"),
      grow: 0.5,
      selector: row => t("I18N_" + row.class),
      sortable: true,
      sortField: 'class'
    },
    {
      igcColumnType: 'DELETE',
      name: '',
      selector: row => row.id,
      grow: 0.5,
      cell: null
    }
  ];

  // ----- END - Data Table stuff -----


  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <TemplateListView pageState={pageState}
                                                  axiosAPI={axiosAuth_ASSET_MGMT_API}
                                                  apiObjName={'asset-types'}
                                                  listPageTitle={t("I18N_Asset_Type_Mgmt")}
                                                  newObjTooltip={t("I18N_TIP_New_asset_type")}
                                                  searchTooltip={t("I18N_Search")}
                                                  deleteConfirmDialogTitle={t("I18N_Asset_type_del_confirm")}
                                                  deleteObjTooltip={t("I18N_TIP_Delete_entry")}
                                                  tableColumns={tableColumns}
                                                  deletePermission={'BuildingAdminGeneralDeleteAccess'}
                                                  onUIMode={setUIMode}
                                                  onSetPageState={setPageState}
                                                  onSetObjDetails={setObjDetails} /> : null}
      {(uiMode === 'DETAILS') ? <AssetTypeAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />                  : null}
      {(uiMode === 'NEW')     ? <AssetTypeAdminNewView     onUIMode={setUIMode} />                                          : null}

    </Fragment>
  )
}

export default AssetTypeAdmin;
